<div class="sitemap" [ngClass]="{'loading': loading}">
  <ul *ngIf="pages$ | async as _pages" class="sitemap__list sitemap__list--parent">
    <ng-container *ngFor="let page of _pages trackBy: trackByFn">
      <li class="sitemap__list-item sitemap__list-item--parent" *ngIf="page.meta.showSitemap == 'true' || page.meta.showSitemap == '\'true\'' || page.meta.showSitemap == true">
        <a class="sitemap__list-link sitemap__list-item--parent" [routerLink]="'/' + page.url">
          <h2 class="sitemap__item-title">{{page.name}}</h2>
        </a>

        <ul *ngIf="page.children.length > 0" class="sitemap__list sitemap__list--child">
          <ng-container *ngFor="let child of page.children trackBy: trackByFn">
            <li class="sitemap__list-item sitemap__list-item--child" *ngIf="child.meta.showSitemap == 'true' || child.meta.showSitemap == '\'true\'' || child.meta.showSitemap == true">
              <a class="sitemap__list-link sitemap__list-link--child" [routerLink]="(child.meta.redirect || '/' + child.url)">{{child.name}}</a>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>
</div>
